import "../../../styles/shared/fonts.css";
import "../../../styles/shared/icomoon_font.css";
import "../../../styles/shared/icomoon_icons.css";

import '../../../styles/desktop/inner/_bottom.css'

import './../../shared/sideMenu';

((($) => {

})(jQuery));
